let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2qbUV")).then(() => parcelRequire('3NGoY'));